// Chakra imports
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "../../../../components/Card/Card";
import CardHeader from "../../../../components/Card/CardHeader";
import DashboardTableRow from "../../../../components/Tables/DashboardTableRow";
import React from "react";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { DashboardTableItem } from "../../../../types/components";

interface ProjectsProps {
  title: string;
  amount: number;
  captions: string[];
  data: DashboardTableItem[];
}

const Projects: React.FC<ProjectsProps> = ({ title, amount, captions, data }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card p='16px' overflowX={{ sm: "scroll", xl: "hidden" }}>
      <CardHeader p='12px 0px 28px 0px'>
        <Flex direction='column'>
          <Text fontSize='lg' color="#38BBD1" fontWeight='bold' pb='.5rem'>
            {title}
          </Text>
          <Flex align='center'>
            <Icon
              as={IoCheckmarkDoneCircleSharp}
              color='teal.300'
              w={4}
              h={4}
              pe='3px'
            />
            <Text fontSize='sm' color='gray.400' fontWeight='normal'>
              <Text fontWeight='bold' as='span'>
                {amount} done
              </Text>{" "}
              this month.
            </Text>
          </Flex>
        </Flex>
      </CardHeader>
      <Table variant='simple' color={textColor}>
        <Thead>
          <Tr my='.8rem' ps='0px'>
            {captions && Array.isArray(captions) && captions.length > 0 ? captions.map((caption, idx) => {
              return (
                <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : undefined}>
                  {caption}
                </Th>
              );
            }) : null}
          </Tr>
        </Thead>
        <Tbody>
          {data && Array.isArray(data) && data.length > 0 ? data.map((row) => {
            return (
              <DashboardTableRow
                key={row.name}
                name={row.name}
                logo={typeof row.logo === 'string' ? (row.logo as any) : row.logo}
                members={row.members}
                budget={row.budget}
                progression={row.progression}
              />
            );
          }) : null}
        </Tbody>
      </Table>
    </Card>
  );
};

export default Projects;

